
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 100 125"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.5 68.5V76c0 4.3 3.5 7.7 7.8 7.7h57.4c4.3 0 7.8-3.5 7.8-7.7v-7.5h-7V76c0 .4-.4.7-.8.7H21.3c-.4 0-.8-.3-.8-.7v-7.5h-7zM46 17.2v38.2l-8.7-7.8-4.7 5.2 14.5 13c.7.6 1.5.9 2.3.9s1.7-.3 2.3-.9l14.5-13-4.7-5.2-8.5 7.8V17.2h-7z"}})])
          )
        }
      }
    